/* eslint-disable */

import React, { useState } from 'react';
import { Button, Col, Form, Input, Row } from 'antd'; // Import required components
import InputLabel from 'components/InputLabel/index';
import ConfirmModal from 'components/modal/ConfirmModal';
// import InputLabel from 'themes/overrides/InputLabel';
import { Box, Stack, Typography } from '@mui/material';
import MainCard from 'components/MainCard';

const StaticFormPath = ({ data: resData }) => {
	const [showModal, setShowModal] = useState(false);
	const [modalData, setModalData] = useState();
	const onFinish = (values) => {
		handleModalSubmit(values);
	};
	const handleModalSubmit = (values) => {
		// console.log('object', values);
	};
	const boxStyle = {
		overflow: 'auto',
		scrollbarWidth: 'thin',
		'&::-webkit-scrollbar': {
			width: '6px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: '#aeb0b0',
			borderRadius: '6px',
		},
	};
	return (
		<>
			<Box sx={{ border: '1px solid #bababa', borderRadius: '6px', borderTopLeftRadius: '0px', overflow: 'hidden' }}>
				<Stack direction="row" alignItems="center" sx={{ px: 1.2, bgcolor: '#e5e5e5', height: '48.5px' }}>
					<Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ flexGrow: 1 }}>
						<Typography variant="h6">
							Process Step:{' '}
							<Typography variant="span" sx={{ color: '#0000FF' }}>
								{resData?.task?.taskAction}
							</Typography>
						</Typography>
						<Typography variant="h5" sx={{ textAlign: 'right' }}>
							Case No:{' '}
							<Typography variant="span" sx={{ color: '#0000FF' }}>
								{resData?.lynWorkflowInstanceStage?.lynUniqueId}
							</Typography>
						</Typography>
					</Stack>
				</Stack>

				<MainCard border={false} sx={{ ...boxStyle, borderRadius: 0, height: 'calc(100svh - 265.16px)' }}>
					<Form onFinish={onFinish}>
						<Row>
							<Col xs={8}>
								<InputLabel label="Location" head={true} />
							</Col>
							<Col xs={16}>
								<Form.Item name="pcoLocation" rules={[{ required: true, message: 'Please enter your location' }]}>
									<Input placeholder="Enter your Location" />
								</Form.Item>
							</Col>
						</Row>

						<Form.Item>
							<Box sx={{ display: 'flex', justifyContent: 'end' }}>
								<Button type="primary" htmlType="submit">
									Submit
								</Button>
							</Box>
						</Form.Item>
					</Form>
				</MainCard>
			</Box>

			{/* {showModal && (
				<ConfirmModalWithMessage
					taskName={resData?.task?.name}
					showModal={showModal}
					submitData={submitData}
					setShowModal={setShowModal}
					modalData={modalData}
					handleSubmit={handleModalSubmit}
				/>
			)} */}

			{showModal && <ConfirmModal showModal={showModal} modalData={modalData} setShowModal={setShowModal} handleSubmit={handleModalSubmit} />}
		</>
	);
};

export default StaticFormPath;
